import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { GlobalConfig } from '../models/global-config.model';

@Injectable({
  providedIn: 'root',
})
export class AdminSettingsService {
  constructor(private apiService: ApiService) {}

  public getAll(): Observable<GlobalConfig[]> {
    return this.apiService.get<GlobalConfig[]>('/AdminSettings');
  }

  public update(configName: string, value: string): Observable<GlobalConfig> {
    return this.apiService.put<GlobalConfig>(`/AdminSettings/${configName}`, {
      value,
    });
  }
}
